// const imageApi = "http://localhost:30006/uploads/.tmp/"; qwertyui
const imageApi = "https://baicserver.baicuae.com/uploads/.tmp/";
export default imageApi;
 